import * as React from 'react';
import * as debounce from 'lodash.debounce';
import './FrequentlyPurchasedProducts.scss';
import frequentlyPurchasedServiceInstance from '../../services/products/FrequentlyPurchasedService';
// import ProductCatalog from 'src/components/ProductCatalog';
import ProductModel from 'src/model/product.model';
import listService from 'src/services/lists/ListsService';
import { ifLoggedIn, goToPartDetail, goToHome } from 'src/utils/navigation';
import ProductCard from '../ProductCard/ProductCard';
import Paginator from 'src/components/common/Paginator';
import Breadcrumbs from '../common/Breadcrumbs';
import i18n from 'src/translation/i18n';
import backArrow from '../../assets/back-arrow';
import { analyticsListNames } from 'src/analytics/constant';
interface IFrequentlyPurchasedProductsProps {
  paginator: any;
  handlePageChange(event: any): any;
  fireProductImpressionEvent(data: any): void;
  fireProductClickEvent(data: any): void;
}

interface IFrequentlyPurchasedProductsState {
  isLoading: boolean;
  products: ProductModel[];

  activePage: number;
}

class FrequentlyPurchasedProducts extends React.Component<
  IFrequentlyPurchasedProductsProps,
  IFrequentlyPurchasedProductsState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      isLoading: true,
      products: [],
      activePage: 1
    };
  }

  public handleBuyNow = (productId: string) => {
    const productClicked = this.state.products.find(
      product =>
        `${product.manufacturerCode}  ${product.productNumber}` === productId
    );
    productClicked['position'] =
      this.state.products.indexOf(productClicked) + 1;
    this.props.fireProductClickEvent({
      product: productClicked,
      list: analyticsListNames.FREQUENTLY_PURCHASED_VIEW_ALL
    });
    ifLoggedIn(() => goToPartDetail(productId));
  };

  private getProducts = () => {
    frequentlyPurchasedServiceInstance.getProducts().then(res => {
      this.setState({
        isLoading: false,
        products: res
      });
      this.fireProductImpressionAnalytics();
    });
  };

  private handleToggleFavorite = (
    name: string,
    category:string,
    mfc: string,
    favorite: boolean,
    favoriteId: number
  ) => {
    if (favorite) {
      listService.deleteItem(favoriteId).then(res => this.getProducts());
    } else {
      if(category?.trim() === "WSER") {
        goToPartDetail(`${mfc}  ${name}`);
        return;
      }
      listService
        .addItem('favorites', name, mfc)
        .then(res => this.getProducts());
    }
  };

  private reloadList = () => {
    this.getProducts();
  };

  private handleOnPageChange = (pageNumber: number) => {
    this.setState({ activePage: pageNumber });
  };

  public componentDidMount() {
    this.getProducts();
  }

  private fireProductImpressionAnalytics = () => {
    if (this.props.fireProductImpressionEvent) {
      this.props.fireProductImpressionEvent({
        products: this.state.products,
        list: analyticsListNames.FREQUENTLY_PURCHASED_VIEW_ALL
      });
    }
  };

  public render() {
    return (
      <div>
        <div className="rp-view-all-list-container">
          <img
            className="rp-back-arrow-view-all"
            src={backArrow}
            alt="RP-Back-To-Page"
            onClick={goToHome}
          />
          <Breadcrumbs>
            {i18n.t('common.home')} / {i18n.t('common.frequentlyPurchased')}
          </Breadcrumbs>
        </div>
        <div className="row no-gutters rp-frequent-products-section">
          {this.state.products.length > 0 &&
            this.state.products.map((product, index) => (
              <ProductCard
                key={index}
                part={product}
                id={product.productNumber}
                name={product.productNumber}
                category={product.category}
                mfc={product.manufacturerCode}
                description={product.description}
                price={product.partnerPrice}
                msrp={product.retailPrice}
                image={product.imageUrls !== null ? product.imageUrls[0] : ''}
                handleOnClicBuyNow={this.handleBuyNow}
                handleToggleFavorite={this.handleToggleFavorite}
                inStock={product.inStock}
                favorite={product.favorite}
                favoriteId={product.idFavoriteItem}
                deal={!!product.discountInfo}
                state={product.state}
                stateDescription={product.stateDescription}
                reloadPart={this.reloadList}
                // paginator={this.props.paginator}
              />
            ))}
        </div>
        {/* <div className="row no-gutters rp-top-products-pagination">
          {this.state.products.length >= 10 ? (
            <Paginator
              activePage={this.state.activePage}
              totalPages={Math.round(this.state.products.length / 10)}
              totalItems={this.state.products.length}
              itemsPerPage={10}
              onPageChanged={this.handleOnPageChange}
            />
          ) : (
            <span />
          )}
        </div> */}
      </div>
    );
  }
}
export default FrequentlyPurchasedProducts;
